module.exports = __webpack_public_path__ + "static/feature_bg1-6a7f3b4f28a8a9939c3056775fd879fe.png";